export const PRIMARY_FONT = "'Montserrat', sans-serif";
export const SECONDARY_FONT = "'Roboto', sans-serif";
